import React, { useEffect, useState } from 'react';
import { Menu, X } from 'lucide-react';
export const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 10) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${isScrolled ? 'bg-glass py-3 backdrop-blur-lg' : 'bg-transparent py-5'}`} data-id="element-279">
      <div className="container mx-auto px-4 md:px-6" data-id="element-280">
        <div className="flex items-center justify-between" data-id="element-281">
          <div className="flex items-center" data-id="element-282">
            <a href="#" className="flex items-center" data-id="element-283">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/2hdfmJveDkd4qR1c9E26iB/munis_verse_blue_logo.jpg" alt="MUNISVerse Logo" className="h-12 w-12 mr-2 rounded-full logo-glow" data-id="element-284" />
              <span className="text-2xl font-bold ml-1" data-id="element-285">
                MUNIS<span className="text-gradient font-extrabold" data-id="element-286">Verse</span>
              </span>
            </a>
          </div>
          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-8" data-id="element-287">
            <a href="#about" className="text-gray-300 hover:text-white hover:text-gradient font-medium transition-colors duration-300" data-id="element-288">
              About
            </a>
            <a href="#services" className="text-gray-300 hover:text-white hover:text-gradient font-medium transition-colors duration-300" data-id="element-289">
              Services
            </a>
            <a href="#how-it-works" className="text-gray-300 hover:text-white hover:text-gradient font-medium transition-colors duration-300" data-id="element-290">
              We Build Buyer Confidence
            </a>
            <a href="#testimonials" className="text-gray-300 hover:text-white hover:text-gradient font-medium transition-colors duration-300" data-id="element-291">
              Testimonials
            </a>
            <a href="#contact" className="btn-gradient text-white px-5 py-2 rounded-md transition-all duration-300 hover:shadow-[0_0_15px_rgba(48,197,232,0.6)]" data-id="element-292">
              Book a Demo
            </a>
          </nav>
          {/* Mobile Menu Button */}
          <button className="md:hidden text-white" onClick={() => setIsMenuOpen(!isMenuOpen)} data-id="element-293">
            {isMenuOpen ? <X size={24} data-id="element-294" /> : <Menu size={24} data-id="element-295" />}
          </button>
        </div>
      </div>
      {/* Mobile Navigation */}
      {isMenuOpen && <div className="md:hidden bg-glass backdrop-blur-lg absolute top-full left-0 right-0 shadow-lg py-4" data-id="element-296">
          <div className="container mx-auto px-4 flex flex-col space-y-4" data-id="element-297">
            <a href="#about" className="text-gray-300 hover:text-gradient font-medium transition-colors py-2" onClick={() => setIsMenuOpen(false)} data-id="element-298">
              About
            </a>
            <a href="#services" className="text-gray-300 hover:text-gradient font-medium transition-colors py-2" onClick={() => setIsMenuOpen(false)} data-id="element-299">
              Services
            </a>
            <a href="#how-it-works" className="text-gray-300 hover:text-gradient font-medium transition-colors py-2" onClick={() => setIsMenuOpen(false)} data-id="element-300">
              We Build Buyer Confidence
            </a>
            <a href="#testimonials" className="text-gray-300 hover:text-gradient font-medium transition-colors py-2" onClick={() => setIsMenuOpen(false)} data-id="element-301">
              Testimonials
            </a>
            <a href="#contact" className="btn-gradient text-white px-5 py-2 rounded-md inline-block" onClick={() => setIsMenuOpen(false)} data-id="element-302">
              Book a Demo
            </a>
          </div>
        </div>}
    </header>;
};